import { useState, useEffect } from 'react';

const SIDEBAR_STATE_KEY = 'codemerlin_sidebar_collapsed';

/**
 * Hook to manage the sidebar's collapsed state with LocalStorage persistence.
 *
 * Defined in specs/010-dashboard-layout-navigation/research.md
 */
export function useSidebarState() {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    try {
      const saved = localStorage.getItem(SIDEBAR_STATE_KEY);
      return saved !== null ? JSON.parse(saved) : false;
    } catch (error) {
      console.error('Error reading sidebar state from localStorage:', error);
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STATE_KEY, JSON.stringify(isCollapsed));
    } catch (error) {
      console.error('Error saving sidebar state to localStorage:', error);
    }
  }, [isCollapsed]);

  const toggleSidebar = () => setIsCollapsed((prev) => !prev);

  return {
    isCollapsed,
    setIsCollapsed,
    toggleSidebar,
  };
}
